<template>
  <v-container>
    <v-row>
      <v-col
        v-for="(card, index) in cards"
        :key="index"
        cols="12"
        :md="cards.length === 1 ? 12 : 6"
        :xl="cards.length === 1 ? 12 : cards.length === 2 ? 6 : 4"
      >
        <Card
          :key="card.title"
          :title="$t(card.title)"
          :text="$t(card.text)"
          :image="card.image"
          :url="card.url"
          :to="card.to"
          :tutorial-name="card.tutorialName"
          :eservice="card.eservice"
          :layers="card.layers"
          :qlayers="card.qlayers"
          :bbox="card.bbox"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// @ is an alias to /src
import axios from 'axios'

export default {
  name: 'Private',
  components: {
    Card: () => import('@/components/Card')
    // Map: () => import('@/components/Map')
  },
  data: () => ({
    publicPath: process.env.BASE_URL,
    cards: undefined
  }),
  created () {
    axios
      .get(`${this.publicPath}api/cardsPrivate.json`)
      .then(response => (this.cards = response.data))
  }
}
</script>
